// src/router/index.js
import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import Home from '@/views/Home.vue'
import Register from '@/views/Register.vue'
import Login from '@/views/Login.vue'

// views
import Dashboard from '@/views/Dashboard.vue'

import DropsHome from '@/views/DropsHome.vue'
import ClaimCdk from '@/views/ClaimCdk.vue'
import GameList from '@/views/cdk/GameList.vue'
import AutoTaskLayout from '@/views/task/AutoTaskLayout.vue'
// import AutoTaskView from '@/views/task/AutoTaskView.vue'
import TaskList from '@/views/task/TaskList.vue'
import TaskCreate from '@/views/task/TaskCreate.vue'
import KickRewards from '@/views/KickRewards.vue'


const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  // 在你的路由配置文件中添加
  {
      path: '/login',
      name: 'Login',
      component: Login
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    children: [
      {
        path: 'home',
        name: 'DropsHome',
        component: DropsHome
      },
      {
        path: 'claimcdk',
        name: 'ClaimCdk',
        component: ClaimCdk,
        children: [
          {
            path: 'gamelist',
            name: 'gamelist',
            component: GameList
          }
        ]
      },
      {
        path: 'kickrewards',
        name: 'KickRewards',
        component: KickRewards
      },
      // {
      //   path: 'autotask',
      //   name: 'AutoTaskView',
      //   component: AutoTaskView
      // },
      {
        path: 'autotask',
        component: AutoTaskLayout,
        children: [
          {
            path: 'autotask',
            redirect: 'list'
          },
          {
            path: 'list',
            component: TaskList
          },
          {
            path: 'create',
            component: TaskCreate
          }
        ]
      }
      
    ]
  }
]


const router = createRouter({
  // history: createWebHistory(),
  history: createWebHashHistory(),
  routes
})

export default router